import React from 'react';
import { Card } from 'react-bootstrap';
import moment from 'moment';

export const RegisterHeaderSummary = ({ history, account, formatCurrency, balanceOverride, endDate }) => {
  const displayBalance = balanceOverride !== undefined ? balanceOverride : (account ? account.balance : 0);

  return (
    <>
      <div className="mb-3">
        <button 
          onClick={() => history.goBack()} 
          className="btn btn-link text-secondary font-weight-bold text-decoration-none p-0 border-0 align-baseline"
          style={{ background: 'none', outline: 'none' }}
        >
          <i className="fas fa-arrow-left mr-2"></i>Back
        </button>
      </div>

      {account && (
        <Card className="mb-4 border-0 shadow-sm bg-light">
          <Card.Body className="d-flex justify-content-between align-items-center py-3 px-4">
            <div>
              <h2 className="mb-1 font-weight-bold text-dark">{account.name}</h2>
              <span className="text-muted small text-uppercase font-weight-bold">
                {account.accountNumber ? `${account.accountNumber} • ` : ''}{account.type}
              </span>
            </div>
            <div className="text-right">
              <span className="text-muted small d-block font-weight-bold text-uppercase">
                {endDate ? `Balance (as of ${moment.utc(endDate).format('MM/DD/YYYY')})` : 'Current Balance'}
              </span>
              <h3 className="mb-0 font-weight-bold text-primary">{formatCurrency(displayBalance)}</h3>
            </div>
          </Card.Body>
        </Card>
      )}
    </>
  );
};
